import script from "./Create.vue?vue&type=script&setup=true&lang=js"
export * from "./Create.vue?vue&type=script&setup=true&lang=js"

import "./Create.vue?vue&type=style&index=0&id=51290a0e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51290a0e"]])

export default __exports__